import React, {useState, useEffect} from 'react';
import axios from 'axios';
import "./UploadSingleFile.css";
import {Button, TextField} from "@mui/material";
import {IoIosCloseCircle} from "react-icons/io";
import {LocalizationProvider, DesktopDatePicker} from '@mui/x-date-pickers';
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns';
import CustomAlert from "../ConfirmationModal/CustomAlert";

const UploadFileToCaseDetail = ({onClose, caseDetail, onDetailChange}) => {
    const [file, setFile] = useState(null);
    const [deadline, setDeadline] = useState(null);
    const [alertInfo, setAlertInfo] = useState({show: false, message: '', type: ''});

    const formatDate = (dateString) => {
        if (dateString === '0001-01-01T00:00:00') {
            return 'თარიღი არ მოიძებნა';
        }

        const date = new Date(dateString);
        if (isNaN(date)) {
            return 'თარიღი არ მოიძებნა';
        }

        return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()}`;
    };

    useEffect(() => {
        function handleEscapeKey(event) {
            if (event.key === "Escape") {
                onClose();
            }
        }

        function handleClickOutside(event) {
            if (event.target.classList.contains('upload-single-popup')) {
                onClose();
            }
        }

        document.addEventListener('keydown', handleEscapeKey);
        document.addEventListener('click', handleClickOutside);

        return () => {
            document.removeEventListener('keydown', handleEscapeKey);
            document.removeEventListener('click', handleClickOutside);
        };
    }, [onClose]);

    const handleFileChange = (event) => {
        setFile(event.target.files[0]);
    };

    const handleUpload = async () => {
        if (!file) return;

        const reader = new FileReader();
        reader.onload = async (e) => {
            const base64String = e.target.result.split(',')[1];  // Split to remove 'data:*/*;base64,'
            const payload = {
                id: caseDetail.id,
                value: formatDate(deadline),
                declined: caseDetail.declined,
                deadline: deadline.toISOString(),
                fileClass: {
                    base64String: base64String,
                    ext: file.name.split('.').pop()
                },
                hasDeadline: caseDetail.hasDeadline,
                hasFile: caseDetail.hasFile
            };

            try {
                await axios.post(`${process.env.REACT_APP_API_BASE_URL}/UpdateCaseDetails`, payload);

            } catch (error) {
            }
            onDetailChange()
            setAlertInfo({show: true, message: 'Upload failed', type: 'error'});
            onClose();

        };
        reader.readAsDataURL(file);
    };

    return (
        <div className="upload-single-popup">
            <div className="upload-single-container">
                <IoIosCloseCircle className="upload-single-close-icon" onClick={onClose}>Close</IoIosCloseCircle>
                <div className="upload-single-header">
                    <span className="case-key">{caseDetail.key}</span>
                </div>
                <div className="upload-single-body">
                    <input type="file" onChange={handleFileChange}/>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DesktopDatePicker
                            label="თარიღი"
                            inputFormat="MM/dd/yyyy"
                            value={""}
                            onChange={setDeadline}
                            renderInput={(params) => <TextField {...params} />}
                        />
                    </LocalizationProvider>

                </div>
                <div className="upload-single-footer">
                    <Button
                        style={{width: "100%"}}
                        variant="contained"
                        onClick={handleUpload}
                        disabled={!file || deadline === null}
                    >
                        ატვირთვა
                    </Button>
                </div>
                {alertInfo.show && (
                    <CustomAlert
                        message={alertInfo.message}
                        type={alertInfo.type}
                        onClose={() => setAlertInfo({...alertInfo, show: false})}
                    />
                )}
            </div>
        </div>
    );
};

export default UploadFileToCaseDetail;
